import React from 'react';
import times from 'lodash/times';
import { ModalHeader } from '../OPL/Modal/ModalHeader';
import { Shimmer } from '../OPL/Shimmer/Shimmer';
import { ModalBody } from '../OPL/Modal/ModalBody';
import { Modal } from '../OPL/Modal/Modal';

export const CurrentYearAssumptionsSettingsLoading = () => {
  return (
    <Modal isOpen>
      <ModalHeader>
        <Shimmer width={150} height={32} />
      </ModalHeader>

      <ModalBody>
        {times(3).map((key, index) => (
          <Shimmer key={key} height={64} mt={index !== 0 ? 16 : 0} />
        ))}
      </ModalBody>
    </Modal>
  );
};
